<template>
    <div
        class="fixed inset-0 bg-modal flex items-center justify-center z-50 p-4"
        @click="emit['close-modal']"
    >
        <!-- アップロード画面 -->
        <UploadVideoInputView
            v-show="windowType == 'input'"
            @close-modal="emit('close-modal')"
            @upload-video:start="handleUploadVideoStart"
            @upload-video:failed="handleUploadVideoFailed"
            @upload-video:video="updateVideo"
        />

        <!-- 追加情報入力 -->
        <AdditionalVideoInfoInputView
            v-show="windowType == 'additional'"
            :video="video"
            @close-modal="emit('close-modal')"
            @submit-additional-info="windowType = 'completion'"
        />

        <!-- アップロード成功モーダル -->
        <UploadCompletion v-if="windowType == 'completion'" @close-modal="emit('close-modal')"/>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, toRef, onMounted, onUnmounted } from 'vue';
import UploadCompletion from './UploadCompletion.vue';
import UploadVideoInputView from './UploadVideoInputView.vue';
import AdditionalVideoInfoInputView from './AdditionalVideoInfoInputView.vue';

// 背景スクロールの制御
onMounted(() => {
    // bodyのスクロールを無効化
    document.body.style.overflow = 'hidden'
});

onUnmounted(() => {
    // コンポーネントが破棄される時にスクロールを復元
    document.body.style.overflow = ''
});

const props = defineProps({
    selectedVideo: { type: Object, default: null },
});
const emit = defineEmits(['close-modal']);
const windowType = ref(props.selectedVideo?.video_id ? "additional" : "input"); //input: 入力画面, additional: 追加項目, completion: 完了画面
// VideoManagementで選択された場合はそちらを使用する
const video = props.selectedVideo ? toRef(props.selectedVideo) : ref({});

const updateVideo = (newVideo) => {
    video.value = newVideo;
};

const handleUploadVideoStart = () => {
    windowType.value = 'additional';
}

const handleUploadVideoFailed = () => {
    windowType.value = 'input';
}

</script>

<style scoped>
/* ラジオボタンのカスタムスタイル */
input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 24px;
    height: 24px;
    border: 2px solid #D1D5DB;
    border-radius: 50%;
    outline: none;
    cursor: pointer;
    position: relative;
}

input[type="radio"]:checked {
    border-color: #059669;
}

input[type="radio"]:checked::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #059669;
}

input[type="radio"]:focus {
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
}
</style>
